import React from 'react'
import { IStep2ProfessionalCategory } from '../../interfaces/Step2'
import { ProfessionalCategory } from './Options'
import MySelect from '../formGroup/MySelect'
import { useTriggerChangeHook } from '../../hooks/triggerChangeHook'

const Step2ProfessionalCategory = (props: IStep2ProfessionalCategory) => {
  const { register, onChange, errors } = props
  const professional_category = useTriggerChangeHook('professional_category')

  return (
    <MySelect
      options={ProfessionalCategory}
      value={professional_category || ''}
      register={register}
      name="professional_category"
      id="professional_category"
      error={errors}
      className="colMd6 pr3lg mb25"
      label="Statut social"
      required
      onChange={onChange}
      resetSelectWithId="professional_subcategory"
    />
  )
}

export default Step2ProfessionalCategory
